import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';

import { isPortrait } from '../../utils/size';

const ContainerNormal = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

const ImageNormal = styled.img`
    border-radius: 50%;
    max-height: ${props => props.size}px;
    object-fit: cover;
    object-position: center;
    height: ${props => props.size}px;
    width: ${props => props.size}px;
    max-width: ${props => props.size}px;
`;

export const RoundImage = props => (
    <ContainerNormal>
        <ImageNormal
            src={props.src}
            className="ie-object-fit-cover-polyfill"
            size={(() => {
                if (props.size) {
                    return props.size;
                } else if (isPortrait() && props.isLongText) {
                    return 90;
                } else if (isPortrait()) {
                    return 105;
                } else {
                    return 120;
                }
            })()}
            onError={e => (e.target.src = DefaultRepImageURL())}
        />
    </ContainerNormal>
);

RoundImage.propTypes = {
    src: PropTypes.any.isRequired,
    isLongText: PropTypes.bool,
    size: PropTypes.number
};

export default RoundImage;
